import { FC, Fragment, ReactNode, useEffect, useState } from 'react';
import { useLocale } from '@adsk/alloy-react-locale';
import { setLanguage, setLocale } from '../helpers/i18n';

export interface LocalizationProviderProps {
  loader?: ReactNode;
}
const LocalizationProvider: FC<LocalizationProviderProps> = ({
  loader = null,
  children = null,
}) => {
  const [isLocalizationLoaded, setIsLocalizationLoaded] = useState(false);
  const { locale } = useLocale(() => undefined);

  useEffect(() => {
    if (locale) {
      setLanguage(locale);
      setLocale(locale);
      setIsLocalizationLoaded(true);
    }
  }, [locale]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <Fragment>{isLocalizationLoaded ? children : loader}</Fragment>;
};

LocalizationProvider.displayName = 'LocalizationProvider';

export default LocalizationProvider;
